import AppointmentStatus from "../appointment/AppointmentStatus";
import {Option} from "ts-option";
import Address from "../address/Address";
import IndividualContact from "../contact/IndividualContact";
import User from "../user/User";
import AppointmentType from "../appointment/AppointmentType";
import DictionaryItem from "../dictionary/DictionaryItem";

/**
 * Event for maps.
 */
export default class Event {
	/**
	 *
	 * @param {string} id
	 * @param {string} title
	 * @param {string} desc
	 * @param {Date} start
	 * @param {Date} end
	 * @param {AppointmentStatus} status
	 * @param {IndividualContact} contact
	 * @param {Option<Address>} address
	 * @param {Option<DictionaryItem>} referenceType type of lead / job
	 * @param {string} referenceId lead / job type
	 * @param {string} referenceNumber lead / job reference number.
	 * @param {Option<AppointmentType>} appointmentType
	 * @param {Option<User[]>} salesEngineers
	 * @param {boolean} isLeadAppointment
	 */
	constructor(public readonly id: string,
		public readonly title: string,
		public readonly desc: string,
		public readonly start: Date,
		public readonly end: Date,
		public readonly status: AppointmentStatus,
		public readonly contact: IndividualContact,
		public readonly address: Option<Address>,
		public readonly referenceType: Option<DictionaryItem>,
		public readonly referenceId: string,
		public readonly referenceNumber: string,
		public readonly appointmentType: Option<AppointmentType>,
		public readonly salesEngineers: Option<User[]>,
		public readonly isLeadAppointment: boolean) {}

	getReferenceTitle() {
		return `${(this.isLeadAppointment ? "LEAD" : "JOB")}-${this.referenceNumber}`
	}
}